import React from "react";
import { Route } from "react-router-dom";
import { PublicLayout } from "@/components/layouts/publicLayout";
import { Login } from "@/pages/public/Login";
import Orcamento from "@/pages/public/Orcamento";

const PUBLIC_PATHS = {
  SIGN_IN: "/login",
};

/**
 * Rotas abertas que valem com ou sem sessão. Ficam separadas das demais porque
 * o roteador monta PublicRoutes só quando `signed` é falso — a página de
 * orçamento precisa abrir para quem está logado também (a secretaria manda o
 * link, o próprio time confere a tela).
 */
const OPEN_PATHS = {
  ORCAMENTO: "/orcamento",
};

const OpenRoutes: React.FC = () => (
  <Route path={OPEN_PATHS.ORCAMENTO} element={<Orcamento />} />
);

const PublicRoutes: React.FC = () => (
  <Route element={<PublicLayout />}>
    <Route path={PUBLIC_PATHS.SIGN_IN} element={<Login />} />
    <Route path="/" element={<Login />} />
  </Route>
);

export { PUBLIC_PATHS, OPEN_PATHS, OpenRoutes };
export default PublicRoutes;
